import { useEffect } from "react";

import { useState } from "react";

export const useResolution = () => {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth)
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth)
      setIsDesktop(window.innerWidth >= 1024);
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    
    // Initial check
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isDesktop, isMobile, innerWidth };
}
